module.exports = __webpack_public_path__ + "img/feedback_nav.a568e467.jpg";